import React from "react";
import "./EntityIndexItem.css";

/** Fila común para cualquier índice operativo: equipos, mantenimientos y futuros listados. */
export default function EntityIndexItem({ title, subtitle, tags = [], status, selected = false, onClick }) {
  return <button type="button" className={"mp-entity-index-item" + (selected ? " is-selected" : "")} aria-pressed={selected} onClick={onClick}>
    <div className="mp-entity-index-item__head"><strong>{title}</strong>{status ? <span className={"mp-entity-index-status " + (status.tone || "neutral")}>{status.label}</span> : null}</div>
    {subtitle ? <p>{subtitle}</p> : null}
    {tags.filter(Boolean).length ? <footer>{tags.filter(Boolean).map((tag, index) => {
      const item = typeof tag === "string" ? { label: tag, tone: "neutral" } : tag;
      return <span className={"mp-entity-index-tag " + (item.tone || "neutral")} key={item.label + "-" + index}>{item.label}</span>;
    })}</footer> : null}
  </button>;
}
